module.exports = __webpack_public_path__ + "img/_0006_图层-8.d606d01c.png";